import $ from 'jquery';
import 'bootstrap/js/dist/tab';
import RevealWhenVisible from '../../components/reveal-when-visible';
import Structure from '../../components/structure';
import FlavourVariantsSlider from '../../components/flavour-variants-slider';
$(() => {
    RevealWhenVisible.init();
    Structure.init();
    FlavourVariantsSlider.init();
});
